import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {defaultErrorHandler} from '../../../context/context';
import customFormsV2Client from '../../../infrastructure/acerill/custom-forms-v2-client';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';
import {TextField} from '../../../libs/react-components-admin/fields/text-like-field';
import SelectField from '../../../libs/react-components-admin/fields/select-field';
import SaveCancelBar from '../../../libs/react-components-admin/buttons/save-cancel-bar';
import Section from '../../../libs/react-components-admin/section/section';
import MultiFormSelector from '../../forms/multi-form-selector';

const RecaptchaKeyPair = () => {

  const {keyPairId} = useParams();

  const [model, setModel] = useState();

  useEffect(() => { loadKeyPair().catch(defaultErrorHandler); }, []);

  const loadKeyPair = () => {
    setModel(null);
    const buildEmptyKeyPair = () => ({
      id: keyPairId,
      version: (window.location.search || '').indexOf('key_version=v2') >= 0 ? 'v2' : 'v3',
    });
    return customFormsV2Client
      .findRecaptchaKeyPairById(keyPairId)
      .then(keyPair => setModel(keyPair || buildEmptyKeyPair()));
  };

  const isModelValid = () => model.id && model.version && model.siteKey && model.secretKey;

  const save = () => customFormsV2Client.saveRecaptchaKeyPair(model);

  const content = () => {
    return <>
      <TextField id="name"
                 label="Name"
                 helpBlock={<>Helps you identify these keys</>}
                 value={model.name}
                 onChange={value => setModel({...model, name: value})}/>
      <SelectField id="version"
                   label="Version"
                   values={[{value: 'v2', label: 'v2'}, {value: 'v3', label: 'v3'}]}
                   value={model.version}
                   onChange={value => setModel({...model, version: value})}/>
      <TextField id="siteKey"
                 label="Site key"
                 helpBlock={<>Enter the site key from your reCAPTCHA account</>}
                 value={model.siteKey}
                 onChange={value => setModel({...model, siteKey: value})}/>
      <TextField id="secretKey"
                 label="Secret key"
                 helpBlock={<>Enter the secret key from your reCAPTCHA account</>}
                 value={model.secretKey}
                 onChange={value => setModel({...model, secretKey: value})}/>
      <label className="form-label">Forms</label>
      <div className="ms-md-4">
        <MultiFormSelector initialValue={model.formIds}
                           onChange={formIds => setModel({...model, formIds: formIds})}/>
        <div className="form-text">These reCAPTCHA keys will be used for all the forms above</div>
      </div>

      <div className="w-100 my-5"/>
      <SaveCancelBar saveAction={() => save()}
                     cancelAction={() => loadKeyPair()}
                     saveDisabled={!isModelValid()}
                     errorHandler={defaultErrorHandler}/>
    </>;
  };

  return <Section title="Integration - reCAPTCHA" noMargin={true}>
    <div className="row justify-content-center">
      <div className="col-12 col-md-8">
        {!model ? <CenteredSpinner/> : content()}
      </div>
    </div>
  </Section>;
};

export default RecaptchaKeyPair;
